import React from "react";
import styled from "@emotion/styled";
import ProductStatusCard from "./_components/ProductStatusCard";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { Flex } from "antd";
import Header from "@components/header/Header";
import { useQuery } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";

const Home = () => {
  const { getInventoryStatistics } = useApiRequest();

  const theme = useTheme();

  const { data: inventoryStatistics, isLoading } = useQuery({
    queryKey: ["inventoryStatistics"],
    queryFn: getInventoryStatistics,
  });

  if (isLoading) {
    return null;
  }

  return (
    <>
      <Header />

      <Container>
        <ProductStatusCard
          completed_sales={inventoryStatistics?.completed_sales ?? 0}
          sales_product={inventoryStatistics?.sales_product ?? 0}
          sales_product_ratio={inventoryStatistics?.sales_product_ratio ?? 0}
          stock_product={inventoryStatistics?.stock_product ?? 0}
          stock_product_ratio={inventoryStatistics?.stock_product_ratio ?? 0}
          temp_product={inventoryStatistics?.temp_product ?? 0}
          total_product={inventoryStatistics?.total_product ?? 0}
        />

        <Flex justify="space-between" vertical gap="20px">
          <Flex vertical>
            <Descriptions>이제 자동으로 카테고리를 분류하고</Descriptions>
            <Descriptions> 상품을 빠르게 등록하세요.</Descriptions>
          </Flex>

          <Image
            src={theme.image.home_timer_image.default}
            width="100%"
            height="100%"
            fit="contain"
          />

          <Flex vertical align="end">
            <Descriptions>창고에서 바로</Descriptions>
            <Descriptions> 재고 업로드부터 판매까지!</Descriptions>
          </Flex>
        </Flex>
      </Container>
    </>
  );
};

export default Home;

const Descriptions = styled.div(({ theme }) => ({
  fontSize: "2rem",
  fontWeight: theme.fontWeight.bold,
  lineHeight: "3rem",
}));

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  padding: "2rem",
  gap: "2rem",
  backgroundColor: "#F4F4F4",
  height: "calc(100dvh - 13.5rem)",
  overflow: "auto",
});
